export default __webpack_public_path__ + "static/media/BaharTitle.caeb8eee.svg";